
import { useModalStateContext } from "../../../../contexts/ModalStateContext"
import DialogIncluirEditarCultura
    from "../../../../screens/ReceituarioAgronomico/components/MICulturas/DialogIncluirEditarCultura";
import DialogIncluirEditarPraga
    from "../../../../screens/ReceituarioAgronomico/components/MIPragas/DialogIncluirEditarPraga";
import DialogIncluirEditarIngredienteAtivo
    from "../../../../screens/ReceituarioAgronomico/components/MIIngredientesAtivos/DialogIncluirEditarIngredienteAtivo";
import DialogIncluirAgrotoxico
    from "../../../../screens/ReceituarioAgronomico/components/MIAgrotoxicos/DialogIncluirAgrotoxico";
import DialogIncluirPrescricao
    from "../../../../screens/ReceituarioAgronomico/components/MIPrescricoes/DialogIncluirPrescricao";

export default function ModaisReceituario() {

    const { modais, handleToggleModal } = useModalStateContext()

    return (
        <>
            {
                modais.receituarioAgronomico.incluirCultura &&
                <DialogIncluirEditarCultura
                    defaultValue={null}
                    open={modais.receituarioAgronomico.incluirCultura}
                    handleClose={() => {
                        handleToggleModal("receituarioAgronomico", "incluirCultura", false)
                    }}
                />
            }

            {
                modais.receituarioAgronomico.incluirPragas &&
                <DialogIncluirEditarPraga
                    defaultValue={null}
                    open={modais.receituarioAgronomico.incluirPragas}
                    handleClose={() => {
                        handleToggleModal("receituarioAgronomico", "incluirPragas", false)
                    }}
                />
            }

            {
                modais.receituarioAgronomico.incluirIngredientesAtivos &&
                <DialogIncluirEditarIngredienteAtivo
                    defaultValue={null}
                    open={modais.receituarioAgronomico.incluirIngredientesAtivos}
                    handleClose={() => {
                        handleToggleModal("receituarioAgronomico", "incluirIngredientesAtivos", false)
                    }}
                />
            }

            {
                modais.receituarioAgronomico.IncluirAgrotoxico &&
                <DialogIncluirAgrotoxico
                    defaultValue={null}
                    open={modais.receituarioAgronomico.IncluirAgrotoxico}
                    handleClose={() => {
                        handleToggleModal("receituarioAgronomico", "IncluirAgrotoxico", false)
                    }}
                />
            }

            {
                modais.receituarioAgronomico.incluirPrescricoes &&
                <DialogIncluirPrescricao
                    defaultValue={null}
                    open={modais.receituarioAgronomico.incluirPrescricoes}
                    handleClose={() => {
                        handleToggleModal("receituarioAgronomico", "incluirPrescricoes", false)
                    }}
                />
            }
        </>
    )
}
